import { render, staticRenderFns } from "./remit.vue?vue&type=template&id=3a922381&scoped=true"
import script from "./remit.vue?vue&type=script&lang=js"
export * from "./remit.vue?vue&type=script&lang=js"
import style0 from "./remit.vue?vue&type=style&index=0&id=3a922381&prod&lang=scss&scoped=true"
import style1 from "./remit.vue?vue&type=style&index=1&id=3a922381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a922381",
  null
  
)

export default component.exports